import * as React from 'react';
import styled from 'styled-components';

export const Arrow = (props: { open: boolean }) => {
  return (
    <Svg
      width="20"
      height="26"
      viewBox="0 0 43 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      open={props.open}
    >
      <path
        d="M2.05347 1.53195L21.476 22.7344L41.0059 1.6309"
        stroke="#e8c893"
        strokeWidth="2"
      ></path>
    </Svg>
  );
};

const Svg: any = styled.svg`
  transform: rotate(${(props: any) => (props.open ? '180deg' : '0deg')});
  margin: 0 30px 0 0;
  position: relative;
  top: 4px;
  float: right;
  //transition: all 0.5s ease-out;

  @media (min-width: 1140px) {
    margin: 0;
    top: 0;
  }
`;
